import jwt from "jsonwebtoken";
import moment from "moment";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  isJsonString,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const employees = {
  state: {
    employee: [],
    selectedBranch: "",
    total: 0,
    count: 0,
    oneEmployee: {},
    bonusEmployee: [],
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
    changeSelectedBranch(state, payload) {
      state.selectedBranch = payload;
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getListEmployeeService(payload = {}, rootState) {
      const _this = this;
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      payload.sort = [["createdAt", "DESC"]];
      return fetch(
        DomainAPI +
          Channel +
          "/api/secure/employeeServices/getListEmployeeService",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            result.data.list.map((item) => {
              if (isJsonString(item.arrBranch)) {
                let arrBranch = JSON.parse(item.arrBranch);
                item.branchCodes = arrBranch.map((e) => {
                  if (e.branchCode) {
                    return e.branchCode;
                  } else {
                    return e;
                  }
                });
              } else {
                let arrBranch = item.arrBranch;
                item.branchCodes = arrBranch.map((e) => {
                  if (e.branchCode) {
                    return e.branchCode;
                  } else {
                    return e;
                  }
                });
              }
              return item;
            });
            _this.setState({
              employee: result.data.list,
              total: result.data.total,
              count: result.data.count,
            });
          } else _this.setState({ employee: [] });
          return result;
        })
        .catch((error) => {
          _this.setState({ employee: [] });
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async findByCode(payload = {}, rootState) {
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/employeeServices/findByCode",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateEmployeeService(payload, rootState) {
      let data = payload.employee;
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI +
          Channel +
          "/api/secure/employeeServices/updateEmployeeService",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async deleteEmployeeService(payload, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/employeeServices/deleteEmployeeService";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async createEmployeeService(payload = {}, rootState) {
      let data = payload.employeeData;
      let url =
        DomainAPI +
        Channel +
        "/api/secure/employeeServices/createEmployeeService";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async createActiveCode(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/activeCode/createCodeInviteEmployee";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async checkActiveCode(payload, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/employeeServices/createEmployeeService";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },

    async getListEmployeeSalary(payload, rootState) {
      let formatDate = payload.year + "-" + payload.month;
      let from = moment(formatDate).format("YYYY-MM-DD");
      let to = moment(formatDate).endOf("month").format("YYYY-MM-DD");
      let url =
        DomainAPI +
        Channel +
        "/api/secure/employeeServices/getListEmployeeSalary";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ from: from, to: to }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getInfoEmployeeFromOrder(payload, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/employeeServices/getInfoEmployeeFromOrder";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ userCodeArray: payload }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getInfoForReport(payload, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/employeeServices/getInfoForReport";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ oneEmployee: result.data });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getEmployeeBonus(payload, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/employeeBonus/getEmployeeBonus";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ bonusEmployee: result.data });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async findModuleRoleForEmployee(payload, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/employeeServices/findModuleRoleForEmployee";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default employees;
